import VBtnToggle from './VBtnToggle'

VBtnToggle.install = function install (Vue) {
  Vue.component(VBtnToggle.name, VBtnToggle)
}

export default VBtnToggle



// WEBPACK FOOTER //
// ./src/components/VBtnToggle/index.js